const keys = () => ({
  googleMapsApiKey: 'AIzaSyDnV8UqQ59_YBJLeyK4tdhkUJbGuSj89Nw',
  fcmPublicVapidKey: 'BFt4OHMlFpiHSpRuEnsq0BUKTSaUZAByVEGOsGz39Y5JlMLxmkWqLwURJ4a2hS9JzKBnWGO6HLw_qx4RvkeQCwA',
  fcmSenderId: '426849266713',
})

export default keys
